module.exports = __webpack_public_path__ + "img/fwsjmbanner1.5b242888.svg";